import { setWorkspaceCount } from "../lib/utility";
import { userDetailStore } from "../stores/userDetailStore";
import { httpService } from "./httpService";

export const userDetailService = {
  async fetchDetail() {
    try {
      userDetailStore.setLoading(true); // Set loading state
      const userDetailResponse = await httpService.getRequest<any>("oauth/users");
      const userDetail = userDetailResponse.data;

      if(userDetail.workspaces !== undefined && userDetail.workspaces !== null) {
        setWorkspaceCount('fs3_workspace_count', userDetail.workspaces);
      }

      const profileChannel = new BroadcastChannel('profile_updates');
      profileChannel.postMessage(userDetail);

      userDetailStore.setUserDetail(userDetail); // update user detail and reset loading
    } catch (error) {
      console.error("Error fetching user details:", error);
      userDetailStore.setLoading(false); // Reset loading on error
    }
  },

  update(uniqueUserId: string, formData: FormData) {
    formData.append("_method", "PUT");
    return httpService.postFormDataRequest(`users/${uniqueUserId}`, formData);
  },

  logoutAllSessions() {
    return httpService.getRequest("oauth/tokens/revoke-all");
  }
};